import HeadDirection from './HeadDirection'
import { AnimationComponentProps as Props } from './phaseAnimation'

export default function HeadLeft(props: Props) {
  return <HeadDirection direction="left" {...props} />
}
